import { diffObject } from '@/helpers/resourceful/compare'

export const transformCustomerContractStoreRequest = (payload) => {
  const { expired_date, total_vehicle, contract_duration, max_mileage, ...rest } = payload

  return {
    ...rest,
    contract_duration: contract_duration ? Number.parseInt(contract_duration) : undefined,
    max_mileage: max_mileage ? Number.parseFloat(max_mileage) : undefined,
  }
}

export const transformCustomerContractUpdateRequest = (newData, oldData) => {
  const [{ expired_date, total_vehicle, contract_duration, max_mileage, ...diff }, _] = diffObject(
    newData,
    oldData
  )

  return {
    ...diff,
    contract_duration: contract_duration ? Number.parseInt(contract_duration) : undefined,
    max_mileage: max_mileage ? Number.parseFloat(max_mileage) : undefined,
  }
}

export const transformCustomerContractShowResponse = (data) => {
  const transformed = {
    customer_id: data?.customer?.id,
    third_party_id: data?.third_party_id,
    contract_source: data?.state?.name,
    contract_type: data?.contract_type,
    city: data?.city,
    custodian_id: data?.custodian?.id,
    contract_duration: data?.contract_duration,
    contract_period: data?.contract_period,
    effective_date: data?.effective_date,
    max_mileage: data?.max_mileage,
    note: data?.note,
    total_vehicle: data?.total_vehicle,
    reference: data?.reference,
  }

  return transformed
}

export const transformCustomerContractVehicleShowRequest = (data) => {
  const transformed = {
    vehicle_id: data.vehicle?.id,
    vehicle_type_id: data.vehicle_type?.id,
    driver_user_id: data.driver_user?.id,
    driver_user_2_id: data.driver_user_2?.id,
    total_mileage: data.total_mileage,
    return_date: data.return_date,
  }

  return transformed
}

export const transformCustomerContractVehicleStoreRequest = (payload) => {
  const { total_mileage, return_date, ...rest } = payload

  return rest
}

export const transformCustomerContractVehicleUpdateRequest = (newData, oldData) => {
  const [diff, _] = diffObject(newData, oldData)

  return diff
}
